import { render } from "./AboutLayout.vue?vue&type=template&id=bcbff4d2"
import script from "./AboutLayout.vue?vue&type=script&lang=js"
export * from "./AboutLayout.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__